/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CarAttentionKindDto = {
    DeadlineOverdue: 'DEADLINE_OVERDUE',
    DeadlineDueSoon: 'DEADLINE_DUE_SOON',
    DeadlinePlannedDatePassed: 'DEADLINE_PLANNED_DATE_PASSED',
    DeadlineMissing: 'DEADLINE_MISSING',
    IssueGrounded: 'ISSUE_GROUNDED',
    IssueOpen: 'ISSUE_OPEN',
} as const;

export type CarAttentionKindDto = typeof CarAttentionKindDto[keyof typeof CarAttentionKindDto];



